import React from 'react'

import FlightResults from "../../components/Flight/FlightResults";

export default function FlightBooking({ history })  {
  
  return <FlightResults page={-1} history={history}/>
}
